import "../../css/pages/newsroom.scss";
import BasePage from "./base";
import tabsToggle from "../modules/tabsToggle";
import tabsExplorer from "../modules/tabsExplorer";
import accordion from "../modules/accordion";

class NewsroomPage extends BasePage {
    constructor(...opts) {
        super(...opts);
    }

    init() {
        super.init();
    }

    onReady() {
        super.onReady();
        tabsToggle.init();
        tabsExplorer.init();
        window.addEventListener("load", accordion.init);
    }
}

new NewsroomPage();
